export const AppConfig = {
  // Company Info
  PRODUCT_NAME: "Forgeworks.ai",
  PRODUCT_NAME_SHORT: "Forgeworks",
  SUPPORT_EMAIL: "support@forgeworks.ai",
  LINKEDIN_URL:
    "https://www.linkedin.com/company/forgeworksai/posts/?feedView=all",
  PRODUCT_URL: "https://app.forgeworks.ai",
  PRODUCT_SERVICES_URL: "https://forgeworks.ai/services",
  SERVICES_URL: "https://forgeworks.ai/services",
  VERSION: "1.0.0",

  // Assets
  LOGO_URL: "https://cdn.forgeworks.ai/assets/forgeworks-logo-orange.png",

  // Messaging
  BACKEND_UNAVAILABLE_MESSAGE:
    "Our servers are currently at lunch. They're hardworking, promise they'll be back soon.",

  // Dynamic Fields
  updateConfig: (
    newConfig: Partial<{
      LOGO_URL: string;
      BACKEND_UNAVAILABLE_MESSAGE: string;
    }>
  ) => {
    if (newConfig.LOGO_URL) AppConfig.LOGO_URL = newConfig.LOGO_URL;
    if (newConfig.BACKEND_UNAVAILABLE_MESSAGE)
      AppConfig.BACKEND_UNAVAILABLE_MESSAGE =
        newConfig.BACKEND_UNAVAILABLE_MESSAGE;
  },
};
